import styled from 'styled-components';
import { prem } from 'styles/helpers/spacing';

const TrimaInvitationWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: ${prem(20)} ${prem(20)};
  max-width: ${prem(420)};
  margin: 0 auto;
  min-height: 100%;
  gap: ${prem(20)};

  .trima-close-btn {
    position: absolute;
    top: ${prem(16)};
    right: ${prem(16)};
    background: none;
    border: none;
    cursor: pointer;
    color: var(--ion-text-color-secondary);
    width: ${prem(36)};
    height: ${prem(36)};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border-radius: 50%;
    -webkit-tap-highlight-color: transparent;

    svg {
      width: ${prem(20)};
      height: ${prem(20)};
    }
  }

  .trima-illustration {
    width: ${prem(96)};
    height: ${prem(96)};
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--ion-color-primary);
    margin-bottom: ${prem(8)};

    svg {
      width: 100%;
      height: 100%;
    }
  }

  h1 {
    font-size: ${prem(22)};
    font-weight: 700;
    margin: 0;
    color: var(--ion-text-color);
    line-height: 1.3;
  }

  .trima-subtitle {
    font-size: ${prem(15)};
    line-height: 1.5;
    color: var(--ion-text-color-secondary);
    margin: 0;
  }

  .trima-duration {
    display: inline-flex;
    align-items: center;
    gap: ${prem(6)};
    font-size: ${prem(13)};
    color: var(--ion-text-color-secondary);
    background: var(--ion-color-light, #f4f4f4);
    padding: ${prem(6)} ${prem(12)};
    border-radius: ${prem(16)};
  }

  .trima-warning {
    font-size: ${prem(13)};
    color: var(--ion-text-color-secondary);
    font-style: italic;
    line-height: 1.4;
    margin: 0;
  }

  .trima-buttons {
    display: flex;
    flex-direction: column;
    gap: ${prem(12)};
    width: 100%;
    margin-top: ${prem(12)};
  }
`;

export { TrimaInvitationWrapper };
